import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxSpinnerModule } from "ngx-spinner";
import { AuthRoutingModule } from "./auth-routing.module";
import { AuthComponent } from "./auth.component";
import { AuthService } from "./auth.service";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { Ng2TelInputModule } from "ng2-tel-input";
import { NgOtpInputModule } from "ng-otp-input";
import { ValidateEqualModule } from "ng-validate-equal";
import { NavigationModule } from '../navigation/navigation.module';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import {MatRadioModule} from '@angular/material/radio';
@NgModule({
  declarations: [
    AuthComponent,

  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxSpinnerModule,
    Ng2TelInputModule.forRoot(),
    NgOtpInputModule,
    ValidateEqualModule,
    MatDatepickerModule,
    MatNativeDateModule, 
    MatRippleModule,
    MatRadioModule,
    NavigationModule
  ],
  providers: [
    AuthService,
  ],
})
export class AuthModule {}
